import {NgModule} from '@angular/core';
import {IgModule} from "./ig/ig.module";
import {FeatureAuthRoutingModule} from "./feature-auth.routing.module";

@NgModule({
    imports: [
        IgModule,
        FeatureAuthRoutingModule
    ],
    exports: [
        IgModule,

    ]
})
export class FeatureAuthModule {
}